import React from 'react'
import Header from '../../components/header/Header'
import Footer from '../../components/footer/Footer'

const Privacy = () => {
    return (
        <>
            <Header />
            <section className='ourServices'>
                <div className="container">
                    <div className="osLeft" style={{width:"100%"}}>
                        <h2>Privacy</h2>
                    </div>
                    {/* <div className="osRight">
                        <p style={{ marginBottom: "0px" }} >Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                    </div> */}
                </div>
            </section>
            <section className='blogContentArea'>

                <div className="container">
                    <div className="blogContent">
                        <p>Last updated: March 31, 2025</p>
                        <p>
                            I-LINE.AI Solutions Private Limited ("the Company", "We", "Us", or "Our") is committed to
                            protecting and respecting Your privacy. This Privacy Policy outlines Our policies and procedures
                            regarding the collection, use, and disclosure of information when You use Our website,
                            applications, or services (collectively, "Service"). It also describes Your privacy rights and how
                            the law safeguards them.
                        </p>
                        <p>
                            By using Our Service, You agree to the collection and use of Your information in accordance
                            with this Privacy Policy.
                        </p>
                    </div>
                    <div className="blogContent">
                        <h2>Definitions
                        </h2>
                        <ul>
                            <li>
                            <strong style={{ color: "#172039" }}>Personal Data:</strong> Any information that relates to an identified or identifiable individual.
                            
                            </li>
                            <li>
                            <strong style={{ color: "#172039" }}>Usage Data:</strong> Information collected automatically, either generated by the use of the
                            Service or from the Service infrastructure itself.
                            </li>
                            <li>
                            <strong style={{ color: "#172039" }}>Cookies:</strong> Small files placed on Your device (computer or mobile device) by a website,
                            containing the details of Your browsing history.
                            </li>
                            <li>
                            <strong style={{ color: "#172039" }}>Service Providers:</strong> Third-party companies or individuals engaged to facilitate the
                            Service or perform services on Our behalf.
                            </li>
                        </ul>
                    </div>
                    <div className="blogContent">
                        <h2>Information We Collect
                        </h2>
                        <p>We collect the following types of information to provide and improve Our Service:
                        </p>
                    </div>
                    <div className="blogContent">
                        <h2>Personal Data:
                        </h2>
                        <ul className='Bullets'>
                            <li><strong style={{ color: "#172039" }}>Identifiable Information:</strong> Name, email address, phone number, address, payment
                                details, and other relevant details provided during registration or while using Our
                                Service.</li>
                        </ul>
                    </div>

                    <div className="blogContent">
                        <h2>Usage Data:
                        </h2>
                        <ul className='Bullets'>
                            <li>Information on how the Service is accessed and used, including IP address, browser 
type, device details, and pages visited.
</li>
                        </ul>
                    </div>

                    <div className="blogContent">
                        <h2>Cookies and Tracking Technologies:
                        </h2>
                        <ul className='Bullets'>
                            <li>
                            We use cookies and similar technologies to monitor activity and store certain 
                            information.
                            </li>
                        </ul>
                    </div>
                    <div className="blogContent">
                        <h2>Location Data Collection and Use: </h2>
                        <p>We collect and process location data to provide essential features and enhance user experience, such as:</p>
                        <ul className='mb-4'>
                        <li><strong>Real-time tracking and navigation</strong> for booking requests and route optimization.</li>
<li><strong>Matching users with nearby services</strong> based on their current location.</li>
<li><strong>Enhancing security and fraud prevention</strong> by verifying locations.</li>
                        </ul>

                        <h2>Data Collection Methods:
                        </h2>
                        <ul className='mb-4'>
                        <li><strong>Foreground tracking:</strong> Location is collected only when the app is in use.</li>
                        <li><strong>Background tracking :</strong> Location may be collected in the background for uninterrupted service.</li>
                        </ul>

                        <h2>User Control & Permissions:</h2>
                        <ul className='mb-4'>
                        <li><strong>Opt-in Required:</strong> Location data is collected only with explicit user consent.</li>
<li><strong>Manage Permissions:</strong> Users can enable/disable location access at any time via device settings.</li>
<li><strong>Data Deletion:</strong> Users can request location data deletion by contacting info@iline.ai.</li>
                        </ul>

                        <h2>Sharing & Storage:</h2>

                        <ul>
                        <li><strong>We do not sell or share location data with third parties</strong> for advertising.</li>
                        <li><strong>Location data is stored securely</strong> and retained only as necessary for service functionality.</li>
                        </ul>

                    </div>

                    <div className="blogContent">
                        <h2>Legal Basis for Processing Personal Data
                        </h2>
                        <p>We process Personal Data based on the following legal grounds:
                        </p>
                        <ol>
                            <li>Your consent.
                            </li>
                            <li>Performance of a contract with You.
                            </li>
                            <li>Compliance with legal obligations.</li>
                            <li>
                            Legitimate interests pursued by Us or a third party, provided these do not override Your 
                            fundamental rights.
                            </li>
                        </ol>
                    </div>

                    <div className="blogContent">
                        <h2>Use of Your Information
                        </h2>
                        <p>
                        We use the collected information for the following purposes:
                        </p>
                        <ol>
                            <li>To provide and maintain Our Service.
                            </li>
                            <li>
                            To notify You about changes to Our Service.

                            </li>
                            <li>To manage Your account and subscriptions.
                            </li>
                            <li>To process payments and verify transactions.
                            </li>
                            <li>To communicate promotional offers, updates, and newsletters (if You opt-in).
                            </li>
                            <li>To improve, personalize, and analyze Our Service.
                            </li>
                            <li>To ensure compliance with legal obligations and safeguard Our rights.
                            </li>
                        </ol>
                    </div>
                    <div className="blogContent">
                        <h2>International Data Transfers
                        </h2>
                        <p>
                        Your information, including Personal Data, may be transferred to and maintained on servers 
located outside of Your state, province, country, or other governmental jurisdiction where data 
protection laws may differ. We ensure appropriate safeguards are in place to protect Your 
information.
                        </p>
                    </div>

                    <div className="blogContent">
                        <h2>Data Retention
                        </h2>
                        <p>
                        We retain Your information only for as long as necessary to fulfill the purposes outlined in this 
Privacy Policy. Usage Data may be retained for internal analysis purposes for a shorter period 
unless required for security or legal obligations.
                        </p>
                    </div>

                    <div className="blogContent">
                        <h2>Sharing Your Information
                        </h2>
                        <p>We may share Your information with:
                        </p>
                        <ol>
                            <li>
                            <strong style={{ color: "#172039" }}>Service Providers:</strong> To facilitate Service delivery, process payments, or analyze Service 
                            usage.
                            </li>
                            <li>
                            <strong style={{ color: "#172039" }}>Affiliates and Partners:</strong> With proper confidentiality agreements.

                            </li>
                            <li>
                            <strong style={{ color: "#172039" }}>Law Enforcement:</strong> When required by law or to protect rights, safety, and property.
                            </li>
                        </ol>
                    </div>

                    <div className="blogContent">
                        <h2>Third-Party Links
                        </h2>
                        <p>
                        Our Service may contain links to third-party websites. We are not responsible for the privacy 
practices or content of these external sites. We encourage You to review the privacy policies of 
any third-party sites You visit.
                        </p>
                    </div>
                    <div className="blogContent">
                        <h2>User-Generated Content
                        </h2>
                        <p>
                        If You post content or interact with others through Our Service, be aware that such interactions 
may be public. We reserve the right to moderate and remove inappropriate content as 
necessary.
                        </p>
                    </div>

                    <div className="blogContent">
                        <h2>Data Security</h2>
                        <p>
                        We employ appropriate technical and organizational measures to protect Your information. 
However, no method of transmission over the Internet is completely secure. While We strive to 
protect Your data, We cannot guarantee its absolute security.
                        </p>
                    </div>

                    <div className="blogContent">
                        <h2>Data Breach Notification
                        </h2>
                        <p>In the event of a data breach, We will notify affected users and relevant authorities within the 
legally required timeframe. Our procedures include measures to mitigate risks and prevent 
future occurrences.</p>
                    </div>

                    <div className="blogContent">
                        <h2>Your Rights
                        </h2>
                        <p>You have the right to:
                        </p>

                        <ol>
                            <li>Access, update, or delete Your Personal Data.</li>
                            <li>Withdraw consent for data processing where applicable.
                            </li>
                            <li>File a complaint with a data protection authority if You believe Your privacy rights have 
been violated.
</li>
                        </ol>
                    </div>

                    <div className="blogContent">
                        <h2>Children's Privacy</h2>
                        <p>
                        Our Service is not intended for individuals under the age of 13. We do not knowingly collect 
personally identifiable information from children without parental consent. If You become 
aware that a child has provided Us with Personal Data, please contact Us, and We will take 
steps to delete such information.

                        </p>
                    </div>

                    <div className="blogContent">
                        <h2>User Responsibilities</h2>
                        <p>
                        You are responsible for maintaining the confidentiality of Your account information and 
ensuring that Your use of the Service complies with applicable laws and the terms of this 
Privacy Policy.
                        </p>
                    </div>

                    <div className="blogContent">
                        <h2>Governing Law and Dispute Resolution
                        </h2>
                        <p>
                        This Privacy Policy is governed by the laws of India. Any disputes arising out of or relating to this 
Privacy Policy will be resolved through arbitration in accordance with the Indian Arbitration and 
Conciliation Act, 1996.
                        </p>
                    </div>

                    <div className="blogContent">
                        <h2>Changes to This Privacy Policy</h2>
                        <p>
                        We reserve the right to update this Privacy Policy from time to time. Any changes will be 
effective immediately upon posting. We encourage You to review this Privacy Policy periodically 
for updates.
                        </p>
                    </div>
                    <div className="blogContent">
                        <h2>Contact Us
                        </h2>
                        <p>
                        If You have any questions or concerns regarding this Privacy Policy or Our data collection 
practices, You can reach out to Us at:

                        </p>
                    </div>
                    <div className="blogContent">
                        <p>Email: info@iline.ai</p>
                        <p>Website: www.iline.ai/privacypolicy</p>
                    </div>
                </div>

            </section>
            <Footer />

        </>
    )
}

export default Privacy
